<template>
  <layout>
    <div>
      <div class="flex items-center">
        <img src="@/assets/images/mv-logo.svg" alt="My Vends 2.0" class="w-12 h-12 mr-2">
        <h2 class="text-4xl tracking-widest">MyVends</h2>
      </div>
      <p class="mt-2 text-lg max-w text-gray-500">
        Reset your password. Verification Code has been send to your email.
      </p>
    </div>

    <div class="mt-8">
      <div class="mt-6">
        <form class="space-y-6" @submit.prevent="reset">
          <error v-if="errorMsg">{{ errorMsg }}</error>
          <text-input v-model="code" type="text" name="code" label="Verification Code" placeholder="Verification Code" :is-loading="isLoading" />
          <text-input v-model="email" type="email" name="email" label="Email address" placeholder="Email address" :is-loading="isLoading" />
          <text-input v-model="newPassword" type="password" autocomplete="new-password" name="new-password" label="Password" placeholder="Password" :is-loading="isLoading" />

          <div class="flex items-center justify-between">
            <div class="text-sm leading-5">
              <router-link :to="{ name: 'ForgotPassword' }" class="text-blumine underline hover:text-big-stone focus:outline-none focus:shadow-outline transition ease-in-out duration-150">
                I didn't recieve verification code
              </router-link>
            </div>
          </div>

          <div>
            <span class="block w-full rounded-md shadow-sm">
              <button
                type="submit"
                :class="{ 'cursor-not-allowed': isLoading }"
                :disabled="isLoading"
                class="w-full flex justify-center items-center py-2 px-4 border border-transparent font-semibold text-base rounded-md text-white bg-big-stone hover:bg-blumine focus:outline-none focus:ring-2 focus:ring-sail focus:shadow-outline-sail active:bg-blumine transition duration-150 ease-in-out">
                <loading v-show="isLoading" class="w-5 h-5 mr-3" /> Change password
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </layout>
</template>

<script>
import { Auth } from '@/services/auth.js'
import Layout from '@/layouts/Auth.vue'
import Loading from '@/components/icons/Loading.vue'
import TextInput from '@/components/form/Text.vue'
import Error from '@/components/form/Error.vue'

export default {
  components: {
    Layout,
    Loading,
    TextInput,
    Error
  },

  data: () => ({
    isAuth: false,
    email: '',
    newPassword: '',
    code: '',
    errorMsg: '',
    isLoading: false
  }),

  methods: {
    navigateToLogin() {
      this.$router.push({ name: 'Login'})
    },
    async reset() {
      this.isLoading = true

      try {
        await Auth.reset(this.email, this.code, this.newPassword)
        this.navigateToLogin()
      } catch (error) {
        this.errorMsg = error.message
      }
      this.isLoading = false
    }
  }
}
</script>
